import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { IBreakdown, IBreakdownCompare } from  '@/interfaces/insightsp2';
import { percent, direction } from  '@/helpers/Insights';
import PercentLabel from './PercentLabel';
import { numberFormatter } from  '@/helpers/Numbers';
import { BuildPath } from  '@/helpers/Paths';
import { IInsightsContext, InsightsContext } from '@/context/InsightsContext';
import Icon from '../icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

const BreakdownCompare = ({dayOne, dayTwo, downloadLink}: {dayOne:IBreakdown[], dayTwo:IBreakdown[], downloadLink:string}) => {

    // Context 
    const context:IInsightsContext = useContext(InsightsContext);

    const [data, setData] = useState<IBreakdownCompare[]>([]);
    
    useEffect(() => {
        if (dayOne && dayTwo){
            
            const dataCompare:IBreakdownCompare[] = [];

            dayOne.map((one, idx) => {

                const day1No = one.number;
                const day2No = dayTwo[idx].number;

                dataCompare.push({
                    image: one.image,
                    percent:percent(day1No, day2No),
                    day1No:day1No,
                    day2No:day2No,
                    label:one.label,
                    ref:one.ref,
                    direction: direction(day1No, day2No)
                });

            });

            setData(dataCompare); 

        }
    }, [dayOne, dayTwo]);

    // Inform context of render finished for loading
    useLayoutEffect(() => {
        context.loadTracker.dispatch({type: 'increment'})
    }, [data]);

    return (
        <div className="breakdown breakdown-compare">

            <ul>
                {data.map((item, idx) => {
                    return(      
                        <li key={idx} className={item.ref}>
                            {(item.ref === "likes") 
                                    ? (<Icon className='image' iconName={IconLibrary.LIKE_ACTIVE} color='#106DE0' sizeInPx='32'/>) 
                                    : <img className="image" src={item.image} alt={""} />     
                            }    
                            <div className={`percent ${item.direction}`}>
                                <PercentLabel item={item} />
                            </div>
                            <span className="compareOf">{numberFormatter(item.day1No)} vs {numberFormatter(item.day2No)}</span>
                            <span className="compareLabel">{item.label}</span>
                        </li>
                    )
                })}    
            </ul>

            <div className="download">
                <a className="download-stats" href={downloadLink} aria-label='Download'>
                    <img src={`${BuildPath()}/images/insightsp2/DownloadStatsBtn.svg`} alt="" />
                </a>
            </div>

        </div>
    );
};

export default BreakdownCompare;